<template>
  <div class="approvalDeatil">
    <ld-header
      class="app-header"
      fixed
      transparent
      white
      :z-index="2"
    >
      <!-- 审批详情  -->
    </ld-header>

    <tk-order-details
      :id="id"
      :is-ldentifying="isLdentifying"
      :showqr-codbox="false"
      v-if="orderType == 11001 || orderType == 11004"
    />
    <alter-ticket-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11003"
    />
    <refund-ticket-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11002"
    />
    <train-order-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11009"
    />
    <train-alter-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11011"
    />
    <train-refund-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11010"
    />
    <ht-order-details
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11007"
    />
    <ht-refund-room-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType==11008"
    />
    <application-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11099"
    />
    <visa-order-detail
      :id="id"
      :is-ldentifying="isLdentifying"
      v-else-if="orderType == 11023"
    />
    <p v-else>
      这个模块暂时没有添加
    </p>

    <!--提交申请-->
    <ld-tabbar
      v-if="active == 1"
      style="height: auto;"
    >
      <ld-button
        defaults
        @click="approvalShow('Reject')"
        v-show="!isLdentifying"
      >
        拒绝
      </ld-button>
      <ld-button
        main4
        @click="approvalShow('Agree')"
      >
        {{ isLdentifying?'确认':'同意' }}
      </ld-button>
    </ld-tabbar>

    <!-- 拒绝审批 Dialog -->
    <van-dialog
      v-model="approvalReject.show"
      title="请输入你的审批意见："
      class="text-center"
      show-cancel-button
      @confirm="approval('Reject', 0)"
    >
      <van-field
        v-model="approvalReject.value"
        placeholder="不大于50字"
      />
    </van-dialog>

    <!-- 同意审批 Dialog -->
    <van-dialog
      v-model="approvalAgree.show"
      title="请输入你的审批意见："
      class="text-center"
      show-cancel-button
      @confirm="approval('Agree', 1)"
    >
      <van-field
        v-model="approvalAgree.value"
        placeholder="同意"
      />
    </van-dialog>
  </div>
</template>

<script>
import { Field } from 'vant'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import { mapGetters } from 'vuex'

import tkOrderDetails from 'Views/Tk/tkOrder/detail.vue'
import alterTicketDetail from 'Views/Tk/tkChange/detail.vue'
import refundTicketDetail from 'Views/Tk/tkRefund/detail.vue'
import trainOrderDetail from 'Views/Tr/trOrder/Detail.vue'
import trainAlterDetail from 'Views/Tr/trChange/ChangeDetail.vue'
import trainRefundDetail from 'Views/Tr/trRefund/RefundDetail.vue'
import htOrderDetails from 'Views/Ht/htOrder/htOrderDetail/index.vue'
import htRefundRoomDetail from 'Views/Ht/htOrder/htRefundDetail/index.vue'
import applicationDetail from 'Views/Home/tripList/detail.vue'
import visaOrderDetail from 'Views/Visa/visaOrder/Detail.vue'

export default {
  components: {
    tkOrderDetails,
    alterTicketDetail,
    refundTicketDetail,
    trainOrderDetail,
    trainAlterDetail,
    trainRefundDetail,
    htOrderDetails,
    htRefundRoomDetail,
    applicationDetail,
    visaOrderDetail,
    [Field.name]: Field,
    ldButton,
    ldTabbar
  },
  data () {
    return {
      active: '1',
      orderType: '',
      approvalAgree: {
        value: '',
        show: false
      },
      approvalReject: {
        value: '',
        show: false,
      },
      isLdentifying:false,//是否确认级
      orderTypePort:[ //获取不同订单类型的审批流
        {orderType:'11001',port:'tkOrder/orderDetail',params:{id:this.$route.query.id}},
        {orderType:'11004',port:'tkOrder/orderDetail',params:{id:this.$route.query.id}},
        {orderType:'11003',port:'tkOrder/tkChangeOrderDetail',params:{changeOrderId:this.$route.query.id}},
        {orderType:'11002',port:'tkOrder/refundOrderDetail',params:{refundId:this.$route.query.id}},
        {orderType:'11009',port:'trOrder/detail',params:{id:this.$route.query.id}},
        {orderType:'11011',port:'trOrder/changeDetail',params:{changeId:this.$route.query.id}},
        {orderType:'11010',port:'trOrder/refundDetail',params:{id:this.$route.query.id}},
        {orderType:'11007',port:'htQuery/hotelOrderDetail',params:{orderId:this.$route.query.id}},
        {orderType:'11008',port:'htQuery/hotelRefundDetail',params:{hotelRefundId:this.$route.query.id}},
        {orderType:'11099',port:'common/vipCcsqdGetInfo',params:{ccsqdId:this.$route.query.id}},
        {orderType:'11023',port:'VisaOrder/VisaOrderDetail',params:{orderId:this.$route.query.id}},
      ]
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.active = this.$route.query.active||'1'
    this.id = this.$route.query.id
    this.orderType = this.$route.query.orderType
    this.getApprovalProgress()
  },
  methods: {
    approvalShow (type) {
      this[`approval${type}`].show = true
    },
    // 送审操作
    approval (type, completeState) {
      let params = {
        appRemark: this[`approval${type}`].value,
        completeState,
        completeWay: 2,
        workItemId: this.$route.query.workItemId
      }
      this.$api['approval/vipBpmReceiveAppResult'](params).then(() => {
        this.$dialog({ message: '审批成功' }).then(() => {
          this.$router.push({path:'/approvalList'})
        })
      })
    },
    getApprovalProgress() { 
      const {id,orderType,orderTypePort} = this
      orderTypePort.forEach(orderObj => {
        if(orderObj.orderType==orderType){
          this.$api[orderObj.port](
            orderObj.params
          ).then(resp=> {
            if(resp.errCode==1){
              const data = {orderId:id,orderType}
              this.$api['approval/vipSpgzGetInfo']({spgzId:resp.data.appId || resp.data.spgzId}).then(res => {
                this.changePageFun(res.data.gznr,data)
              })
            }  
          })
        }
      })
    },
    changePageFun (gznrList,data) { //处理是否是确认级和修改当前active
      this.$api['approval/vipOrderAppProgress'](data).then(res =>{
        if(res.errCode==1){
          const {spjdInfoList,spjd} = res.data
          let spjdStop = parseInt(spjd.charAt(0))-1
          if(spjdInfoList[spjdStop].jblx==1){ //处理是否是确认级 
            this.isLdentifying = true
          }
          var  spl = 0
          for (let i = 0; i < gznrList.length; i++) {
            for (let j = 0; j < gznrList[i].empList.length; j++) {
              if(this.userInfo.empInfo.empNo==gznrList[i].empList[j].empNo){
                spl = i
              }
            }
          }
          if(spjdInfoList[spl].flowState != 3){
            this.active = 2
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.approvalDeatil { 
  .app-header .ld-header.transparent {
    .van-nav-bar__left {
      opacity: 0;
    }
  }
}
</style>


